import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from "@apollo/client"
import { setContext } from "@apollo/client/link/context"

const authLink = setContext((_, { headers }) => {
  return {
    headers: Object.assign(headers || {}, {
      Accept: "application/json",
      Authorization: `Bearer ${process.env.DATOCMS_API_TOKEN}`,
      "Content-Type": "application/json",
      ...(process.env.DATOCMS_ENVIRONMENT && {
        "X-Environment": process.env.DATOCMS_ENVIRONMENT,
      }),
    }),
  }
})

const previewLink = setContext((_, { headers }) => ({
  headers: Object.assign(headers ?? {}, {
    "X-Include-Drafts": "true",
  }),
}))

export const datoClient = (
  preview?: boolean,
): ApolloClient<NormalizedCacheObject> => {
  const firstLinks = preview ? authLink.concat(previewLink) : authLink

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: firstLinks.concat(
      createHttpLink({
        uri: `https://graphql.datocms.com${preview ? "/preview" : ""}`,
      }),
    ),
  })
}
